import React from "react"
import { Link } from "gatsby"
import { useIntl } from "../hooks"
import { IconTwitter, IconFacebook, IconInstagram, IconLinkedin } from "../images/Logos/Brands"
import { IconAndroidAppStore, IconAppleAppStore } from "images/AppStores"
import { routes } from "../helpers"
import { logo } from "../images"

export default function Footer() {
  const { t } = useIntl()

  const directory = [
    {
      id: 1,
      heading: t("Footer__About--Heading"),
      links: [
        {
          id: 1,
          route: routes.about,
          title: t("Footer__About--Company"),
        },
        // {
        //   id: 2,
        //   route: "https://stories.photoshelter.com/photoshelter-acquires-socialie/",
        //   title: "PhotoShelter + Socialie",
        // },
        // {
        //   id: 2,
        //   route: routes.index,
        //   title: t("Footer__About--Customers"),
        // },
      ],
    },

    {
      id: 2,
      heading: t("Footer__Legal--Heading"),
      links: [
        {
          id: 1,
          route: routes.privacyPolicy,
          title: t("Footer__Legal--PrivacyPolicy"),
        },
        {
          id: 2,
          route: routes.eula,
          title: t("Footer__Legal--TermsOfUse"),
        },
        {
          id: 3,
          route: routes.dpa,
          title: t("Footer__Legal--DataProtectionAgreement"),
        },
        {
          id: 4,
          route: routes.securitySchedule,
          title: t("Footer__Legal--SecuritySchedule"),
        },
      ],
    },
    {
      id: 3,
      heading: t("Footer__Contact--Heading"),
      links: [
        {
          id: 1,
          route: routes.requestDemo,
          title: t("Footer__Contact--ContactSocialie"),
        },
      ],
    },
  ]

  const socialLinks = [
    {
      id: 1,
      link: "https://www.facebook.com/socialie/",
      icon: (
        <IconFacebook className="w-2.5 h-2.5 text-body hover:text-facebook transition-colors ease-in-out duration-300" />
      ),
    },
    {
      id: 2,
      link: "https://www.instagram.com/socialie/",
      icon: (
        <IconInstagram className="w-2.5 h-2.5 text-body hover:text-instagram transition-colors ease-in-out duration-300" />
      ),
    },
    {
      id: 3,
      link: "https://www.twitter.com/socialie/",
      icon: (
        <IconTwitter className="w-2.5 h-2.5 text-body hover:text-twitter transition-colors ease-in-out duration-300" />
      ),
    },
    {
      id: 4,
      link: "https://www.linkedin.com/company/socialie",
      icon: (
        <IconLinkedin className="mb-0.5 w-2.5 h-2.5 text-body hover:text-linkedin transition-colors ease-in-out duration-300" />
      ),
    },
  ]
  return (
    <div className="pt-11 bg-lightGrey">
      <div className="container flex flex-col-reverse laptop:flex-row laptop:justify-between mb-4.5">
        <div className="w-full laptop:w-1/4">
          <div className="flex flex-col items-center laptop:items-start">
            <div className="mb-4.5">
              <img src={logo} width={264} height={36} alt="socialie logo" />
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-2.5 mb-2">
              {socialLinks.map((social) => (
                <a
                  key={social.id}
                  href={social.link}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="cursor-pointer"
                >
                  {social.icon}
                </a>
              ))}
            </div>
            {/* End Social Links */}

            {/* App Store Badges */}
            <div className="flex items-center space-x-1">
              <a href="https://socialie.com/ios" rel="noopener noreferrer" target="_blank">
                <IconAppleAppStore />
              </a>

              <a href="https://socialie.com/android" rel="noopener noreferrer" target="_blank">
                <IconAndroidAppStore style={{ width: "155px", height: "60px" }} />
              </a>
            </div>
            {/* End App Store Badges */}
          </div>
        </div>
        <div className="laptop:w-1/2 flex flex-wrap laptop:justify-between">
          {directory.map((dir) => (
            <div key={dir.id} className="w-1/2 mb-6 laptop:mb-1.5 flex flex-col laptop:flex-1 space-y-1.5">
              <p className="text-darkGrey text-p font-black">{dir.heading}</p>
              {dir.links.map((link) => (
                <Link
                  key={link.id}
                  to={link.route}
                  className="text-p text-body tracking-13 hover:text-socialiePink transition-colors duration-300 ease-in-out"
                >
                  {link.title}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="container pb-4.5 flex items-center justify-center laptop:justify-start laptop:items-start">
        <p className="text-darkGrey text-small leading-small tracking-10">{t("Footer__Copyright")}</p>
      </div>
    </div>
  )
}
